module.exports = __webpack_public_path__ + "img/28.3f43e1f2.jpg";